export default "__VITE_ASSET__F34F$MhT__"